module.exports = __webpack_public_path__ + "img/南理工 函授.adbf0503.jpg";